import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import { CreateForm, EditForm } from './views/FormView';
import BaseLayout from '../../components/CabinetBaseLayout';
import useApi from '../../api';

const Component = () => {
  const api = useApi();
  const router = api.router.clubs;
  return (
    <BaseLayout>
      <Switch>
        <Route exact path={router.list()} component={ListView} />
        <Route exact path={router.create()} component={CreateForm} />
        <Route path={router.edit(':id')} component={EditForm} />
      </Switch>
    </BaseLayout>
  );
};

export default Component;
